
    <span
      [ngClass]="{
        'platform-label platform-label--mobile': placement === DevicePlacement.MOBILE || placement === DevicePlacement.MW
       , 'platform-label platform-label--desktop': placement === DevicePlacement.DESKTOP}">
      <i class="far fa-mobile" *ngIf="placement === DevicePlacement.MOBILE || placement === DevicePlacement.MW" matTooltip="Mobile"></i>
      <i class="far fa-desktop" *ngIf="placement === DevicePlacement.DESKTOP" matTooltip="Desktop"></i> 
  </span>